import ProductContainerSearch from './ProductContainerSearch.jsx';

export default ProductContainerSearch;


// WEBPACK FOOTER //
// ./src/components/ProductContainerSearch/index.jsx